export default {
  direction: {},
  directions: [],
}
